import { render, staticRenderFns } from "./PageEventGameTutorialCompleted.vue?vue&type=template&id=b9de3930&scoped=true&"
import script from "./PageEventGameTutorialCompleted.vue?vue&type=script&lang=js&"
export * from "./PageEventGameTutorialCompleted.vue?vue&type=script&lang=js&"
import style0 from "./PageEventGameTutorialCompleted.vue?vue&type=style&index=0&id=b9de3930&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9de3930",
  null
  
)

export default component.exports